<script>

import { Overlay } from '../../'

export default {
    name: 'ChaikinOscillator',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad', version: '1.0.0',
                desc: 'Chaikin Oscillator - Momentum indicator based on ADL',
                preset: {
                    name: 'Chaikin Oscillator $fast $slow',
                    side: 'offchart',
                    settings: {
                        lineWidth: 1.5,
                        color: '#673ab7'
                    }
                }
            }
        },
        use_for() { return ['ChaikinOscillator'] },
        calc() {
            return {
                props: {
                    fast: { def: 3, text: 'Fast Period' },
                    slow: { def: 10, text: 'Slow Period' }
                },
                conf: { renderer: 'Spline' },
                update: `
                    let multiplier = high[0] === low[0] ? 0 : (2 * close[0] - high[0] - low[0]) / (high[0] - low[0])
                    let adl = cum(ts(multiplier * vol[0]))
                    return ema(adl, fast)[0] - ema(adl, slow)[0]
                `
            }
        }
    }
}
</script>
